<style lang="stylus">
    .colorselector
        position fixed
</style>

<template>
    <div class="colorselector" :style="{ left: `${position.left}px`, top: `${position.top}px` }">
        <Palette
            v-if="showColor"
            from="plugin"
            :pluginColor="pluginColor"
            :force="true"
            :useMask="false"
            :windowType="'iconfont'"
            @setColor="setColor"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Palette from "@/app/components/Common/Color/Palette.vue";

    @Component({
        components: {
            Palette,
        },
    })
    export default class ColorSelector extends Vue {
        showColor = false;
        pluginColor = "";
        position = {
            left: 0,
            top: 0,
        };
        positionFit(position) {
            const width = 240;
            const height = 290;
            if (position.left + width > window.innerWidth) {
                position.left -= width;
            }
            if (position.top + height > window.innerHeight) {
                position.top -= height - 12;
            }
            return position;
        }
        showSelector(color, position) {
            this.showColor = !this.showColor;
            if (this.showColor) {
                this.pluginColor = color;
                this.position = this.positionFit(position);
                document.onclick = () => {
                    this.showColor = false;
                    document.onclick = null;
                };
            } else {
                document.onclick = null;
            }
        }
        setColor(color) {
            this.showColor = false;
            document.onclick = null;
            this.$emit("setColor", color);
        }
        mounted() {}
        beforeDestroy() {}
    }
</script>
